<template>
    <div id="clock">

        <span class="time">{{ displayTime }}</span>
        <b-button v-if="!running" @click="modalShow=true"><font-awesome-icon icon="play" /></b-button>
        <b-button v-if="running" @click="modalShow=true"><font-awesome-icon icon="pause" /></b-button>
        <b-button @click="modalShowReset=true"><font-awesome-icon icon="redo" /></b-button>
              
        <b-modal v-model="modalShow" id="modal_password" :title="$t('Timer.text1')" effect="fade/zoom" 
        :ok-title="modalButtonText" :cancel-title="$t('Timer.text2')" @ok="submitPass" @cancel="cancelAction">
          <form @submit.prevent="submitPass" role="form" method="post">
              <div class="form-group">
                  <label><p>{{ $t('Timer.text3') }}</p></label>
                  <input class="form-control" type="password" v-model="chronoUserPass" >
                  <label v-if="!correctPass" class="danger"><p>{{ $t('Timer.text4') }}</p></label>
              </div>
          </form>
        </b-modal>

        <b-modal v-model="modalShowReset" id="modal_reset" :title="$t('Timer.text1')" effect="fade/zoom" 
        :ok-title="$t('Timer.text8')" :cancel-title="$t('Timer.text2')" @ok="submitPassReset" @cancel="cancelActionReset">
          <form @submit.prevent="submitPassReset" role="form" method="post">
              <div class="form-group">
                  <label><p>{{ $t('Timer.text7') }}</p></label>
                  <input class="form-control" type="password" v-model="chronoUserPass" >
                  <label v-if="!correctPass" class="danger"><p>{{ $t('Timer.text4') }}</p></label>
              </div>
          </form>
        </b-modal>

        <b-modal v-model="modalRedirecGame1Show" ok-only ok-variant="secondary" :title="$t('Timer.text10')" 
        effect="fade/zoom" :ok-title="$t('Timer.text13')" @ok="fRedirect">
            <form @submit.prevent="fRedirect" role="form" method="post">
                <div class="form-group">
                  <b-row align-h="center"> 
                    <label><p><strong>{{ $t('Timer.text9') }}</strong></p></label>
                  </b-row>
                  <b-row align-h="center">
                    <label><p>{{ $t('Timer.text11') }}</p></label>
                  </b-row>
                  <b-row align-h="center">
                    <label><p>{{ $t('Timer.text12') }}</p></label>
                  </b-row>                                                                                                                                                                                                                            
                </div>
            </form>
        </b-modal>

        <b-modal v-model="modalRedirecGame2Show" ok-only ok-variant="secondary" :title="$t('Timer.text10')" 
        effect="fade/zoom" :ok-title="$t('Timer.text13')" @ok="fRedirect">
            <form @submit.prevent="fRedirect" role="form" method="post">
                <div class="form-group"> 
                    <b-row align-h="center">
                      <label><p><strong>{{ $t('Timer.text9') }}</strong></p></label>
                    </b-row>
                    <b-row align-h="center">
                      <label><p>{{ $t('Timer.text14') }}</p></label>
                    </b-row>
                    <b-row align-h="center">
                      <label><p>{{ $t('Timer.text15') }}</p></label>                                                                                                                                                                                                                                               
                    </b-row>
                </div>
            </form>
        </b-modal>

        
    </div>     
</template>

<script>    
import {mapState} from 'vuex';

import {bus} from '../main';
    
export default {   
    props:['slide_redirect','timer_seconds','typeGame'],
    data(){
        return {     
            chronoUserPass: '',            
            correctPass: true,
            running: false,
            intervalTimer: null,
            minutes: 0,
            seconds: 0,
            time: 0,
            modalShow: false,
            modalShowReset: false,            
            modalRedirecGame1Show: false,
            modalRedirecGame2Show: false,
        }
    },     
    computed: {
        ...mapState(['slide9','showMenu','slide0Password']),
        displayTime() {
          let time = this.time/60;
          let minutes = parseInt(time);
          let seconds = Math.round((time - minutes) * 60);
          return `${this.zeroPadded(minutes)}:${this.zeroPadded(seconds)}`;
        },
        modalButtonText(){
          if(this.running){
            return this.$t('Timer.text5'); 
          }else{
            return this.$t('Timer.text6'); 
          }
        }
    },
    mounted(){
      this.setTime(this.timer_seconds);
      bus.$on('getTime', this.sendTime);
    },    
    methods:{   
        sendTime(){
          var result = this.timer_seconds - this.time;
          this.$emit('sendTime',result);
        },
        submitPass(bvModalEvt){
          bvModalEvt.preventDefault();
          if(this.chronoUserPass  == this.slide0Password ){
            if(this.running){
              this.stop();
            }else{
              this.start();
            }
            this.modalShow = false;
            this.chronoUserPass="";
            this.correctPass = true;
          }else{
            this.correctPass = false;
          }
        },
        cancelAction(){
          this.chronoUserPass="";
          this.correctPass=true;
        }, 
        submitPassReset(bvModalEvt){
          bvModalEvt.preventDefault();
          if(this.chronoUserPass  == this.slide0Password ){
            this.reset();
            this.modalShowReset = false;
            this.chronoUserPass="";
            this.correctPass = true;
          }else{
            this.correctPass = false;
          }
        },
        cancelActionReset(){
          this.chronoUserPass="";
          this.correctPass=true;
        }, 
        setTime(seconds) {
            clearInterval(this.intervalTimer);
            this.time = seconds;
            this.start();
        },
        start() {    
            this.running = true;            
            if(!this.intervalTimer){
                this.intervalTimer = setInterval(() => {
                  if (this.time > 0) {
                    this.time--;
                  } else {
                    if (this.typeGame=='game1'){
                      this.modalRedirecGame1Show=true;                                                              
                    }else if(this.typeGame=='game2'){
                      this.modalRedirecGame2Show=true; 
                    }
                  }
                }, 1000);
            }
        },
        stop () {
          this.running = false;
          clearInterval(this.intervalTimer);
          this.intervalTimer = null;
        },
        reset(){ 
          this.stop();
          this.setTime(this.timer_seconds);          
        },
        zeroPadded(num) {
            // 4 --> 04
            return num < 10 ? `0${num}` : num;
        },
        fRedirect(){
          clearInterval(this.intervalTimer);
          this.$router.push(this.slide_redirect);
        }
    }          
}
</script>


<style scoped>

@import url('https://fonts.googleapis.com/css?family=Share+Tech+Mono');

.danger{
  color: red;
}

#clock {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  color: #c8c8c8;
  font-family: 'Agency FB', sans-serif;
}
#clock .time {
  font-size: 4.5em;
}
#clock .text {
  margin-top: 30px;
  font-size: 1em;
  color: rgba(200, 200, 200, .15);
  text-align: center;
}
#clock .text a {
  text-decoration: none;
  color: inherit;
  transition: color 0.1s ease-out;
}
#clock .text a:hover {
  color: #c8c8c8;
}
#clock .btn-container {
  display: flex;
  margin-top: 15px;
}
#clock .btn-container a {
  text-align: center;
  font-family: 'Agency FB', sans-serif;
  background: transparent;
  border: none;
  color: #c8c8c8;
  padding: 10px 15px;
  margin: 0 10px;
  text-transform: uppercase;
  font-size: 2em;
  cursor: pointer;
  flex-grow: 1;
  transition: color 0.1s ease-out;
}
#clock .btn-container a:hover {
  color: white;
}


</style>